import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Row, Col, Button, Card, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import TableSearch from "../../../../Components/TableSearch";

import { getAllTaxInspector } from "../../../../actionCreators/TaxInspector";
import { getFilterMetaData } from "../../../../actionCreators/Property";
import { useHistory } from "react-router-dom";
import { transformFilterMetaData } from "../../../../utils";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

function ListTaxInspector({
  getAllTaxInspector,
  taxInspectorList,
  getFilterMetaData,
  filterMetaData,
  user
}) {
  const [isDownloading, setIsDownloading] = React.useState(false);
  const styles = {
    titleButtonParent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      padding: "7px 18px",
      background: "#284F68",
      color: "white",
      borderRadius: "5px",
      fontWeight: "500",
      fontSize: "15px",
      cursor: "pointer",
      marginRight: "8px",
    },
    contentWrapper: {
      marginLeft: "10px",
      marginRight: "10px",
    },
    buttonWrapper: {
      display:"flex",
    }
  };

  const [isDistrictAdmin] = React.useState(user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
  0 ? true : false);
  const [adminDistrictId] = React.useState(user?.currentUser?.data?.district?.id);

  const history = useHistory();

  const displayTotalTaxInspector = (value) =>
    [undefined, null].includes(value) ? "" : ` (${value})`;

  React.useEffect(() => {

    let filterBody = {
      circle: [],
      status: null,
    }
    if(isDistrictAdmin && adminDistrictId) {
      filterBody = JSON.stringify({
        ...filterBody,
        district: [adminDistrictId],
      })
    } else {
      filterBody = JSON.stringify({
        ...filterBody,
        district: [],
      })
    }

    getAllTaxInspector({
      page: 1,
      pageSize: 10,
      searchString: "",
      filterBody: filterBody
    });
    getFilterMetaData();
  }, []);

  React.useEffect(() => {}, [taxInspectorList]);


  const downloadReportHandler = async () => {
    try {
      setIsDownloading(true);

      const res = await axios({
        url: `${baseURL}/users/downloadReport?type=ti&district_id=${isDistrictAdmin && adminDistrictId ? adminDistrictId : null}`,
        method: "GET",
        withCredentials: true,
        responseType: "blob",
        headers: {
          "access-token": JSON.parse(localStorage.getItem("access-token")),
          //"Content-Type": "text/csv",
        },
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "TI User List.xlsx");

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();
      setIsDownloading(false);
    } catch (e) {
      setIsDownloading(false);
    }
  };

  const filterTIData = (x) => {
    const filterBody = x.filterBody;
    if(isDistrictAdmin && adminDistrictId) {
      filterBody.district = [adminDistrictId]
    }
    getAllTaxInspector({
      page: x?.page,
      pageSize: x?.size,
      searchString: x?.searchText,
      filterBody: JSON.stringify(x?.filterBody),
    })
  }
  return (
    <React.Fragment>
      <div style={styles.titleButtonParent}>
        <div>
          <Typography className="heading">{`Tax Inspectors${displayTotalTaxInspector(
            taxInspectorList?.data?.totalRecords
          )}`}</Typography>
        </div>
        <div style={styles.buttonWrapper}>
        <Button
          style={styles.uploadButton}
          type="primary"
          icon={<PlusOutlined />}
          size={"large"}
          onClick={() => history.push("/admin/add-tax-inspector")}
        >
          ADD TI
        </Button>
        <Button
          style={styles.uploadButton}
          type="primary"
          //  icon={<PlusOutlined />}
          size={"large"}
          onClick={() => downloadReportHandler()}
          loading={isDownloading}
        >
          Download Data
        </Button>
        </div>
      </div>

      {[undefined, null].includes(filterMetaData?.data) ? (
        <div className="spin-loader">
          <Spin size="large" />
        </div>
      ) : (
        <Card bordered={false}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <TableSearch
                onRowClick={(x) =>
                  history.push(`/admin/edit-tax-inspector?id=${x?.id}`)
                }
                tableName={"taxInspectors"}
                data={taxInspectorList?.data}
                sendRequestParams={(x) => filterTIData(x)}
                loading={taxInspectorList?.loading}
                filterMetaData={transformFilterMetaData(filterMetaData?.data)}
                isDistrictAdmin={isDistrictAdmin}
              />
            </Col>
          </Row>
        </Card>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = ({
  user: user,
  taxInspector: { taxInspectorList },
  property: { filterMetaData },
}) => ({
  user,
  taxInspectorList,
  filterMetaData,
});

const mapDispatchToProps = (dispatch) => ({
  getAllTaxInspector: bindActionCreators(getAllTaxInspector, dispatch),
  getFilterMetaData: bindActionCreators(getFilterMetaData, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListTaxInspector);
